import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../../../services/apirest";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  Box,
  Stack,
  TextField,
  Snackbar,
  Alert,
  DialogTitle,
  Typography,
  Autocomplete,
  Grid
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { getData } from "../../../../../../services/library";

function AltaChoferZona(props) {
    const [alta, setAlta] = useState(props.alta)
    const [openSnack, setOpenSnack] = React.useState(false);
    const [colormensaje, setColorMensaje] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [choferes, setChoferes] = useState();
    const [choferSeleccionado, setChoferSeleccionado] = useState("")
    const [disbtn, setdisbtn] = useState(false)

    useEffect(() => {
      getData("/choferes/", setChoferes);
    }, []);
    //Snackbar Notificacion
    const handleCloseSnack = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpenSnack(false);
      handleClose()
    };

    const handleClose = () => {
        setAlta(!alta);
      if (props.onClose) {
        props.onClose();
      }
    };

    const guardarZona = async (e) => {     
      setdisbtn(true) 
      e.preventDefault();
      await fetch(UrlApi + "/envasado_chofer_zona", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          zona: props.zona.id,
          chofer: choferSeleccionado.id,
          activo: 1,
        }),
      })
        .then((res) => {
          if (!res.err) {
            console.log("Guardado");
            setOpenSnack(true);
            setColorMensaje("#D4EFDF");
            setMensaje("El Chofer se guardó exitosamente !");
          } else {
            console.log("Error");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  return (
    <>
    <Dialog
        fullWidth
        open={alta}
        onClose={() => handleClose()}
        maxWidth="xl"
      >
     <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Nuevo Chofer en la Zona: {props.zona.nombre}
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={guardarZona}>
        <DialogContent>
            {/* <Box
              backgroundColor="#F4F6F6"
              px={2}
              py={2}
              border={0.5}
              borderColor={"#ABB2B9"}
              borderRadius={3}
            > */}
              <Grid container  spacing={1}>
                <Grid item xs={12} py={1} mb={1}>
                <Autocomplete
                disabled={!choferes}
                required
                disableClearable
                id="chofer"
                // name="id_provincia"
                // style={style}
                size="small"
                noOptionsText={"Chofer INEXISTENTE"}
                options={choferes}
                autoHighlight
                // filterOptions={filterOptions}
                getOptionLabel={(chofer) =>
                  chofer.id + "-" + chofer.nombre_apellido
                }
                // isOptionEqualToValue={(option, value) =>
                //   option.id === value?.id
                // }
                // value={clienteSeleccionado || null}
                // defaultValue={clienteSeleccionado || null}
                onChange={(event, value) => {
                  setChoferSeleccionado(value);
                //   setBuscando(true);
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.id} - {option.nombre_apellido}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Tipee para buscar..."
                    {...params}
                    label="Chofer"
                    focused
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
                </Grid>
              </Grid>
              <Grid container direction="row" justifyContent="space-between" mt={1}>
                <Grid item>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={() => handleClose()}
                    style={{ backgroundColor: "#fff" }}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    color="success"
                    variant="contained"
                    disabled={disbtn}
                    // endIcon={<SaveIcon />}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
           {/* </Box> */}
        </DialogContent>
            </form>
    </Dialog>

    <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
  </>
  )
}

export default AltaChoferZona